import { CfTurnstileChallenge } from 'freedom-shared';

import { sentryModel } from '../model';

let instance: InstanceType<typeof CfTurnstileChallenge> | undefined;

export function getCfTurnstileChallenge() {
  if (instance) {
    return instance;
  }

  if (import.meta.env.VITE_CF_TURNSTILE_SITEKEY) {
    instance = new CfTurnstileChallenge({
      siteKey: import.meta.env.VITE_CF_TURNSTILE_SITEKEY,
      onChallengeError(error, params) {
        sentryModel.captureMessage(`[CF Turnstile] ${error.message}`, {
          // @ts-expect-error HookParams object is serializable for extra
          extra: params,
          level: 'error',
        });
      },
      onWafForbiddenError(params) {
        sentryModel.captureMessage(
          '[CF Turnstile] cf waf forbidden error encountered',
          { level: params.isCleared ? 'error' : 'warning' },
        );
      },
      onInteractiveChallengePrompted() {
        sentryModel.captureMessage(
          '[CF Turnstile] interactive challenge prompted',
          { level: 'warning' },
        );
      },
    });

    return instance;
  }
}
